module.exports = __webpack_public_path__ + "img/xzmp.83a8e1bf.png";